'use strict';

import Swiper from 'swiper';
import { Navigation, Mousewheel, FreeMode } from 'swiper/modules';

const SCROLLER_SELECTOR = '.js-scroller';

export function initialiseScroller(element) {
    const scrollerElement = element.querySelector('.swiper-container');
    if (!scrollerElement) return null;

    const mq = window.matchMedia('(max-width: 999px)');
    let scroller;

    const settings = {
        slidesPerView: 'auto',
        simulateTouch: false,
        modules: [
            FreeMode,
            Mousewheel,
            Navigation,
        ],
        freeMode: {
            enabled: true,
        },
        mousewheel: {
            releaseOnEdges: true,
            forceToAxis: true,
            sensitivity: 0.8,
        },
        navigation: {
            enabled: true,
            nextEl: element.querySelector('.scroller-next'),
            prevEl: element.querySelector('.scroller-prev'),
        },

    };

    const initializeSwiper = () => {
        scroller = new Swiper(scrollerElement, settings);
    };

    const destroySwiper = () => {
        if (scroller) {
            scroller.destroy(true, true);
            scroller = null;
        }
    };

    const handleMediaQueryChange = event => {
        if (event.matches) {
            destroySwiper();
        } else {
            initializeSwiper();
        }
    };

    initializeSwiper();

    mq.addEventListener('change', handleMediaQueryChange);

    // Custom Tab handling (keyboard focus only)
    scrollerElement.addEventListener('focusin', event => {
        if (event.target && event.target.matches(':focus-visible')) { // Check if focus is keyboard-driven
            const focusedElement = event.target;
            const slide = focusedElement?.closest('.swiper-slide');

            if (slide && scroller) {
                scroller.slideTo(scroller.slides.indexOf(slide));
            }
        }
    });

    return scroller;
}

export function init() {
    const activeScrollers = Array.from(document.querySelectorAll(SCROLLER_SELECTOR)).map(initialiseScroller);

    // Fix for Basker Preview
    const observer = new MutationObserver(() => {
        document.querySelectorAll(SCROLLER_SELECTOR).forEach(function (scroller) {
            if (!activeScrollers.some(function (existingScroller) {
                return existingScroller?.el === scroller.querySelector('.swiper-container');
            })) {
                activeScrollers.push(initialiseScroller(scroller));
            }
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });
}
